export default import.meta.ROLLDOWN_FILE_URL_DIfk7kQd$ay11pPyWXH$1A